import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from '../dbconn';
import {API_ROOT} from './../api-config';
import Modal from 'react-responsive-modal';

import Notifications, {notify} from 'react-notify-toast';
import Swal from "sweetalert2";
import ScrollBooster from 'scrollbooster'
import {IMAGE_ROOT} from "../api-config";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
import Language from "./language";

class home extends Component {

    constructor(props, context) {
        super(props, context);

        this.searchTimer = null;
        this.state = {
            redirect: false,
            nosessionredirect: false,
            cartredirect: false,
            windowHeight: 0,
            productList: [],
            searchList: [],
            displayList: [],
            open: false,
            buildItemFlag: false,
            categoryList: [],
            customerName: '',
            multiselectList: [],
            dropdownList: [],
            showBuildItem: false,
            buildItemProductID: 0,
            selectedMod: [],
            cartTotal: 0,
            editItemProductID: this.props.match.params.productID,
            selectedOptions: [],
            buildItemProductPrice: 0,
            buildItemProductQty: 1,
            totalModPrice: 0,
            firstLoad: true,
            productScheduleEnabled: "N",
            refreshTop: true,
            swalButton: '',
            productDetailFlag: false,
            sb: null,
            searchString: '',
            typingTimer: '',
            loyaltyPoints: "0",
        };
    };


    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    onWindowResize = () => {
        this.state.sb.updateMetrics();

        if ($('#nav_side').length) {
            $('#nav_side').height($('.privacyBlock').position().top - $('.search_block').outerHeight() - $('.site_logo').outerHeight());
        }

        /*
        var width = 0;
        $('#nav-main').children('a').each(function () {
            width += $(this).outerWidth(true);
        });


        console.log($('#nav-main').children('a').length + " " + width + " " + $('#nav-main').width());
        //console.log($("#childdiv").width() + " " + $("#nav-main").width());


        if (width < $("#nav-main").width()) {

            $('#sandwich').css('display', 'none');
            console.log("this element is not  overflowing!!");
        }

        else {
            $('#sandwich').css('display', 'inline-block');
            console.log("this element is  overflowing!!");
        }*/
    };


    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });

        sessionStorage.removeItem('editCartID');
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });

        var url = '';
        var categroyUrl = '';

        var get = this;
        $(window).resize(function () {

            get.onWindowResize();
        });


        if (sessionStorage.getItem('guestFlag') == 'Y') {
            this.setState({customerName: 'GUEST'});
            url = API_ROOT + '/fetchmenu?guestFlag=Y&store_id=' + localStorage.getItem('store_id');
            categroyUrl = API_ROOT + '/fetchcategorylist?guestFlag=Y&store_id=' + localStorage.getItem('store_id');

            this.onOpenModal();

            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(menuData => {


                    if (menuData.status == 1) {


                        for (var i = 0; i < menuData.product_data.length; i++) {
                            if (menuData.product_data[i].product_enabled == "N") {

                                this.setState({productScheduleEnabled: "Y"});
                                break;
                            }
                        }

                        this.setState({productList: menuData.product_data});
                        this.setState({displayList: menuData.product_data});
                        this.setState({categoryList: menuData.category_data});
                        this.state.sb.updateMetrics();

                        if (this.state.productScheduleEnabled == "Y") {
                            this.filterProducts(-1, "S");
                        }
                    }
                    this.onCloseModal();
                });

            /* fetch(categroyUrl)
                 .then(response => {
                     return response.json();
                 })
                 .then(categoryData => {


                     if (categoryData.status == 1) {



                     }

                 });
 */
            /* var storeURL = API_ROOT + '/fetchstorestats?guestFlag=Y&store_id=' + localStorage.getItem('store_id');

             fetch(storeURL)
                 .then(response => {
                     return response.json();
                 })
                 .then(storeData => {

                     this.onCloseModal();

                     this.setState({nca: storeData.store_data[0].store_default_nca});
                     this.setState({ncaAmtFlag: storeData.store_data[0].store_nca_amount_flag});
                     this.setState({productMarkupFlag: storeData.store_data[0].store_product_markup_enabled});
                 });*/
        } else {
            var dbconn = new db();

            dbconn.getAll().then(data => {

                if (!data || data.length < 1) {
                    this.setState({nosessionredirect: true});
                } else {

                    this.setState({customerName: data[0].customer_firstname + " " + data[0].customer_lastname});
                    var customer_id = data[0].customer_id;
                    var customer_token = data[0].customer_token;
                    url = API_ROOT + '/fetchmenu?guestFlag=N&customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');
                    categroyUrl = API_ROOT + '/fetchcategorylist?guestFlag=N&customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                    var userUrl = API_ROOT + '/fetchcustomerpoints?customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                    this.onOpenModal();

                    fetch(url)
                        .then(response => {
                            return response.json();
                        })
                        .then(menuData => {


                            if (menuData.status == 1) {

                                for (var i = 0; i < menuData.product_data.length; i++) {
                                    if (menuData.product_data[i].product_enabled == "N") {

                                        this.setState({productScheduleEnabled: "Y"});
                                        break;
                                    }
                                }
                                this.setState({productList: menuData.product_data});
                                this.setState({displayList: menuData.product_data});
                                this.setState({categoryList: menuData.category_data});

                                this.state.sb.updateMetrics();
                                if (this.state.productScheduleEnabled == "Y") {
                                    this.filterProducts(-1, "S");
                                }
                            }
                            this.onCloseModal();
                        });

                    /*   fetch(categroyUrl)
                           .then(response => {
                               return response.json();
                           })
                           .then(categoryData => {


                               if (categoryData.status == 1) {
                                   this.setState({categoryList: categoryData.category_data});

                                   this.state.sb.updateMetrics();

                               }
                           });*/

                    fetch(userUrl)
                        .then(response => {
                            return response.json();
                        })
                        .then(data => {


                            if (data.status == 1) {


                                dbconn.getAllOrder().then(cartList => {

                                    var cartLoyaltyPoints = 0;
                                    for (var i = 0; i < cartList.length; i++) {

                                        if (cartList[i].product_loyalty_enabled == "Y") {
                                            cartLoyaltyPoints += (parseInt(cartList[i].product_quantity) * parseInt(cartList[i].product_loyalty_price));
                                        }
                                    }


                                    this.setState({loyaltyPoints: (parseInt(data.data) - cartLoyaltyPoints) });


                                });

                            }
                        });
                    /* var storeURL = API_ROOT + '/fetchstorestats?guestFlag=Y&store_id=' + localStorage.getItem('store_id');

                     fetch(storeURL)
                         .then(response => {
                             return response.json();
                         })
                         .then(storeData => {

                             this.onCloseModal();

                             this.setState({nca: storeData.store_data[0].store_default_nca});
                             this.setState({ncaAmtFlag: storeData.store_data[0].store_nca_amount_flag});
                             this.setState({productMarkupFlag: storeData.store_data[0].store_product_markup_enabled});
                         });*/
                }
            });
        }
        this.calculateCartTotal();
    }

    componentDidMount() {
        var height = $(window).height();
        this.setState({windowHeight: height});

        window.addEventListener("scroll", (e) => {
            e.preventDefault();
            window.scrollTo(0, 0);
        });

        $('#nav_side').height($('.privacyBlock').position().top - $('.search_block').outerHeight() - $('.site_logo').outerHeight());


        document.title = "Menu - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var viewport = document.querySelector('.topnav');
        var content = viewport.querySelector('.innerDiv');

        var sb = new ScrollBooster({
            viewport, // this parameter is required
            content, // scrollable element
            mode: 'x', // scroll only in horizontal dimension
            onUpdate: (data) => {
                // your scroll logic goes here
                content.style.transform = `translateX(${-data.position.x}px)`
            }
        });

        this.setState({sb: sb});


        $('#topnav').on('mousewheel DOMMouseScroll', function (event) {

            var delta = Math.max(-1, Math.min(1, (event.originalEvent.wheelDelta || -event.originalEvent.detail)));


            $(this).scrollLeft($(this).scrollLeft() - (delta * 40));
            event.preventDefault();

        });


        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        $('.input-number').val(1);


        var cartTotal = (sessionStorage.getItem('cartTotal') == null) ? 0 : sessionStorage.getItem('cartTotal');
        this.setState({cartTotal: cartTotal});


    }

    availHomeLinkClick = e => {
        $('#topnav>.innerDiv>a.first').removeClass('first');
        $('#mySidenav>.innerDiv>a.first').removeClass('first');
        $('.nav_side>a.first').removeClass('first');

        $('#availLink').addClass('first');
        $('#availLink1').addClass('first');
        $('#availLink2').addClass('first');

        this.state.sb.setPosition({
            x: $('#availLink').position().left,
            y: 100
        });
        var newList = this.state.productList.filter(
            (product) => {
                return product.product_enabled == "Y";
            }
        );
        this.setState({displayList: newList});
        this.closeNav();
    }

    homeLink1Click = e => {

        $('#topnav>.innerDiv>a.first').removeClass('first');
        $('#mySidenav>.innerDiv>a.first').removeClass('first');
        $('.nav_side>a.first').removeClass('first');

        $('#homeLink').addClass('first');
        $('#homeLink1').addClass('first');
        $('#homeLink2').addClass('first');

        this.state.sb.setPosition({
            x: $('#homeLink').position().left,
            y: 100
        });
        this.setState({displayList: this.state.productList});
        this.closeNav();
    }
    searchProduct = e => {


        this.setState({searchString: $(e.target).val()});

        console.log($(e.target).id);


        if ($(e.target).val() == "") {
            $('#searchLabel').html('No Results found.');
            console.log($(e.target).val());

            $('#searchList').css('display', 'none');
            $('#productList').css('display', 'inline-block');


            this.setState({searchString: ''});
            this.setState({searchList: []});

        } else {
            console.log($(e.target).val());
            $('#searchLabel').html('Searching...');
            $('#searchList').css('display', 'inline-block');
            $('#productList').css('display', 'none');

        }

        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            this.search(); // count is 0 here
        }, 1000);


        // prints either LoginInput or PwdInput
    };


    search = () => {

        if (this.state.searchString != "") {
            var url = "";
            if (sessionStorage.getItem('guestFlag') == 'Y') {


                url = API_ROOT + '/searchproducts?guestFlag=Y&search=' + this.state.searchString + "&store_id=" + localStorage.getItem('store_id');
                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(menuData => {

                        if (menuData.status == 1) {

                            this.setState({searchList: menuData.product_data});

                            if (menuData.product_data.length > 0) {
                                $('#searchLabel').html('Search Results');
                            } else {
                                $('#searchLabel').html('No Results found.');
                            }

                        }
                    });


            } else {

                var dbconn = new db();

                dbconn.getAll().then(data => {

                    if (!data || data.length < 1) {
                        this.setState({nosessionredirect: true});
                    } else {

                        this.setState({customerName: data[0].customer_firstname + " " + data[0].customer_lastname});
                        var customer_id = data[0].customer_id;
                        var customer_token = data[0].customer_token;
                        url = API_ROOT + '/searchproducts?guestFlag=N&search=' + this.state.searchString + '&customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');


                        fetch(url)
                            .then(response => {
                                return response.json();
                            })
                            .then(menuData => {

                                if (menuData.status == 1) {

                                    this.setState({searchList: menuData.product_data});
                                    if (menuData.product_data.length > 0) {
                                        $('#searchLabel').html('Search Results');
                                    } else {
                                        $('#searchLabel').html('No Results found.');
                                    }
                                }
                            });
                    }
                });
            }
        } else {
            this.setState({searchList: []});
        }

    };

    searchClick = () => {


        if ($('#searchText').css('display') == "none") {
            $('#menuContainer').css('display', 'none');
            $('#searchText').css('display', 'inline-block');
            $('#searchList').css('display', 'inline-block');
            $('#btnSearch').css('top', '0px');
            $('#productList').css('display', 'none');
            $('#searchText input').focus();
            $('#searchText input').val('');
            $('#searchLabel').html('Search Results');
        } else {
            $('#btnSearch').css('top', '-15px');
            $('#menuContainer').css('display', 'block');
            $('#searchText').css('display', 'none');
            $('#searchList').css('display', 'none');
            $('#productList').css('display', 'inline-block');


            this.setState({searchString: ''});
            this.setState({searchList: []});

        }

    };
    logout = () => {

        var dbconn = new db();

        dbconn.deleteAll();
        dbconn.deleteAllOrder();
        localStorage.removeItem("remember");

        this.setState({nosessionredirect: true});
    };


    openCart = event => {
        var dbconn = new db();

        dbconn.getAllOrder().then(products => {
            if (products.length > 0) {
                this.setState({cartredirect: true});
            } else {

                this.state.swalButton.fire({
                    title: i18n.t('cart_empty'),
                    allowOutsideClick: false
                });
            }
        });

    };

    filterProducts = (category_id, source) => {
        var oldList = this.state.productList;

        console.log(source);
        if (source == "S") {


            if (category_id == "0") {
                this.state.sb.setPosition({
                    x: $('#homeLink').position().left,
                    y: 100
                });

                //$('#nav-main').animate({scrollLeft: $('#homeLink').position().left}, 500);
            } else if (category_id == "-1") {
                this.state.sb.setPosition({
                    x: $('#availLink').position().left,
                    y: 100
                });

                //$('#nav-main').animate({scrollLeft: $('#homeLink').position().left}, 500);
            } else {


                this.state.sb.setPosition({
                    x: $('#cat_' + category_id).position().left,
                    y: 100
                });
                //$('#nav-main').animate({scrollLeft: $('#cat_' + category_id).position().left}, 500);
            }

            // $('#nav-main').scrollTo($('#cat_' + category_id))
            //console.log($('#nav-main').scrollLeft()+" "+$('#cat_' + category_id).offset().left);
            // $('#nav-main').scrollLeft($('#cat_' + category_id).offset().left);


        } else {


            if (category_id != "0") {


                //    $('#mySidenav').animate({scrollTop: $('#sideCat_' + category_id).position().top}, 500);
            }

        }


        if (category_id == 0) {
            $('#topnav>.innerDiv>a.first').removeClass('first');
            $('#mySidenav>.innerDiv>a.first').removeClass('first');
            $('.nav_side>a.first').removeClass('first');

            $('#homeLink').addClass('first');
            $('#homeLink1').addClass('first');
            $('#homeLink2').addClass('first');

            this.setState({displayList: oldList});
        } else if (category_id == -1) {
            $('#topnav>.innerDiv>a.first').removeClass('first');
            $('#mySidenav>.innerDiv>a.first').removeClass('first');
            $('.nav_side>a.first').removeClass('first');

            $('#availLink').addClass('first');
            $('#availLink1').addClass('first');
            $('#availLink2').addClass('first');

            var newList = oldList.filter(
                (product) => {
                    return product.product_enabled == "Y";
                }
            );
            this.setState({displayList: newList});
        } else {

            var newList = oldList.filter(
                (product) => {
                    return product.category_id == category_id;
                }
            );

            $('#topnav>.innerDiv>a.first').removeClass('first');
            $('#mySidenav>.innerDiv>a.first').removeClass('first');
            $('.nav_side>a.first').removeClass('first');

            $('#cat_' + category_id).addClass('first');
            $('#sideCat_' + category_id).addClass('first');
            $('#leftcat_' + category_id).addClass('first');

            this.setState({displayList: newList});
        }
        this.state.sb.updateMetrics();
        this.closeNav();
    };

    itemNotAvailable = (time) => {
        this.state.swalButton.fire({
            title: i18n.t('item_not_available') + ' ' + time + ".",
            allowOutsideClick: false
        });
    }

    goToProduct = (product_id, position) => {

        //alert(this.state.displayList[position].modifier_count + " " + this.state.displayList[position].product_notes_enabled == "Y");
        if (this.state.displayList[position].modifier_count > 0 || this.state.displayList[position].product_notes_enabled == "Y") {

            this.setState({productDetailFlag: true});


            sessionStorage.setItem("product_id", product_id);
            sessionStorage.setItem("type", "A");
            sessionStorage.setItem("loyalty", "N");
            sessionStorage.setItem("quantity", parseInt($('#quant_' + product_id).val()));
        } else {

            var dbconn = new db();

            this.state.displayList[position].product_modifiers = [];
            this.state.displayList[position].product_notes = "";
            this.state.displayList[position].product_loyalty_enabled = "N";
            this.addProductToCart(this.state.displayList[position], parseInt($('#quant_' + product_id).val()))
        }


    };
    clickSearchProduct = (product_id, position) => {

        //alert(this.state.displayList[position].modifier_count + " " + this.state.displayList[position].product_notes_enabled == "Y");
        if (this.state.searchList[position].modifier_count > 0 || this.state.searchList[position].product_notes_enabled == "Y") {

            this.setState({productDetailFlag: true});


            sessionStorage.setItem("product_id", product_id);
            sessionStorage.setItem("type", "A");
            sessionStorage.setItem("loyalty", "N");
            sessionStorage.setItem("quantity", 1);
        } else {

            var dbconn = new db();

            this.state.searchList[position].product_modifiers = [];
            this.state.searchList[position].product_notes = "";
            this.state.searchList[position].product_loyalty_enabled = "N";
            this.addProductToCart(this.state.searchList[position], 1);
        }


    };


    addProductToCart = (product, quantity) => {

        var dbconn = new db();
        var cartLength = 0;

        dbconn.getAllOrder().then(products => {

            var flag = false;
            var cartItem = 0;

            dbconn.getAllKeys().then(keys => {

                if (keys.length == 0) {
                    cartLength = 0;
                } else {
                    cartLength = Math.max(...keys);
                }


                products.map((item, index) => {

                    //  alert((parseInt(item.product_id) == parseInt(product.product_id)) + " A" + item.product_notes + " B" + product.product_notes + " C" + (item.product_notes == product.product_notes));
                    if ((parseInt(item.product_id) == parseInt(product.product_id)) && item.product_discount_type != "H" && (item.product_notes == product.product_notes) && (item.product_loyalty_enabled == product.product_loyalty_enabled)) {

                        if (item.product_modifiers.length == product.product_modifiers.length) {

                            var counter = 0;
                            var selectedMod = product.product_modifiers;

                            for (var i = 0; i < selectedMod.length; i++) {

                                for (var j = 0; j < item.product_modifiers.length; j++) {

                                    if (parseInt(selectedMod[i].option_id) == parseInt(item.product_modifiers[j].option_id)) {
                                        counter++;
                                    }
                                }
                            }

                            if (counter == selectedMod.length) {

                                flag = true;
                                cartItem = item;
                            }
                        }
                    }
                });


                if (flag) {

                    //increase quantity
                    dbconn.deleteOrder(parseInt(cartItem.cart_id)).then(data => {

                        console.log(JSON.stringify({
                            product_name: cartItem.product_name,
                            product_name_es: cartItem.product_name_es,
                            product_desc: cartItem.product_desc,
                            product_desc_es: cartItem.product_desc_es,
                            product_id: cartItem.product_id,
                            product_img: cartItem.product_img,
                            product_quantity: parseInt(quantity) + parseInt(cartItem.product_quantity),
                            product_notes: "",
                            product_price: cartItem.product_price,
                            product_original_price: cartItem.product_original_price,
                            product_discount: cartItem.product_discount,
                            product_discount_type: cartItem.product_discount_type,
                            product_modifiers: cartItem.product_modifiers,
                            product_loyalty_enabled: cartItem.product_loyalty_enabled,
                            product_loyalty_price: cartItem.product_loyalty_price,
                            mod_price: cartItem.mod_price,
                            isModifierAvailable: false,
                            cart_id: cartItem.cart_id
                        }));
                        dbconn.setOrder({
                            product_name: cartItem.product_name,
                            product_name_es: cartItem.product_name_es,
                            product_desc: cartItem.product_desc,
                            product_desc_es: cartItem.product_desc_es,
                            product_id: cartItem.product_id,
                            product_img: cartItem.product_img,
                            product_quantity: parseInt(quantity) + parseInt(cartItem.product_quantity),
                            product_notes: cartItem.product_notes,
                            product_price: cartItem.product_price,
                            product_original_price: cartItem.product_original_price,
                            product_discount: cartItem.product_discount,
                            product_discount_type: cartItem.product_discount_type,
                            product_modifiers: cartItem.product_modifiers,
                            product_loyalty_enabled: cartItem.product_loyalty_enabled,
                            product_loyalty_price: cartItem.product_loyalty_price,
                            mod_price: cartItem.mod_price,
                            mod_original_price: 0,
                            isModifierAvailable: false,
                            cart_id: cartItem.cart_id
                        }, cartItem.cart_id).then(dat => {


                            let myColor = {background: '#0E1717', text: "#FFFFFF"};
                            notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);
                            this.calculateCartTotal();

                        });
                    });
                } else {

                    var couponType = sessionStorage.getItem("couponType");

                    var couponDiscount = 0;

                    if (couponType && (couponType == "E" || couponType == "J" || couponType == "K")) {

                        var couponproduct = JSON.parse(sessionStorage.getItem("couponProductDetails"))

                        var count = 0;
                        for (var i = 0; i < couponproduct.length; i++) {

                            for (var j = 0; j < products.length; j++) {
                                if (products[j].product_id == couponproduct[i].product_id && products[j].product_loyalty_enabled == "N" && couponproduct[i].coupon_details_type == "Q") {

                                    count++;
                                }
                            }
                            if (product.product_id == couponproduct[i].product_id && product.product_loyalty_enabled == "N" && couponproduct[i].coupon_details_type == "Q") {
                                count++;
                            }
                        }


                        if (count == couponproduct.length) {
                            couponDiscount = sessionStorage.getItem("couponDiscount");
                            if (couponType == "J") {
                                couponType = "A";
                            } else {
                                couponType = "P";
                            }
                        } else {
                            couponType = "";
                        }
                    } else {
                        couponType = "";
                    }


                    // alert(price);
                    console.log(JSON.stringify({
                        product_name: product.product_name,
                        product_name_es: product.product_name_es,
                        product_desc: product.product_description,
                        product_id: product.product_id,
                        product_img: product.product_image,
                        product_quantity: quantity,
                        product_notes: product.product_notes,
                        product_price: product.product_price,
                        product_original_price: product.product_original_price,
                        product_discount: couponDiscount,
                        product_discount_type: couponType,
                        product_modifiers: product.product_modifiers,
                        product_loyalty_enabled: product.product_loyalty_enabled,
                        product_loyalty_price: product.product_loyalty_price,
                        mod_price: product.modifier_price,
                        mod_original_price:0,
                        isModifierAvailable: false,
                        cart_id: cartLength + 1
                    }));
                    dbconn.setOrder({
                        product_name: product.product_name,
                        product_name_es: product.product_name_es,
                        product_desc: product.product_description,
                        product_desc_es: product.product_description_es,
                        product_id: product.product_id,
                        product_img: product.product_image,
                        product_quantity: quantity,
                        product_notes: product.product_notes,
                        product_price: product.product_price,
                        product_original_price: product.product_original_price,
                        product_discount: couponDiscount,
                        product_discount_type: couponType,
                        product_modifiers: product.product_modifiers,
                        product_loyalty_enabled: product.product_loyalty_enabled,
                        product_loyalty_price: product.product_loyalty_price,
                        mod_price: product.modifier_price,
                        mod_original_price:0,
                        isModifierAvailable: false,
                        cart_id: cartLength + 1
                    }, cartLength + 1).then(dat => {


                        let myColor = {background: '#0E1717', text: "#FFFFFF"};
                        notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);
                        this.calculateCartTotal();
                    });

                }
            });
        });
    };

    calculateCartTotal = () => {


        var cartTotal = 0;
        var dbconn = new db();
        dbconn.getAllOrder().then(products => {

            var couponType = sessionStorage.getItem("couponType");
            if (couponType && couponType == "H") {
                dbconn.deleteAllCouponOrder("H").then(db1 => {
                    dbconn.getAllKeys().then(keys => {

                        var cartLength = 0;
                        if (keys.length == 0) {
                            cartLength = 0;
                        } else {
                            cartLength = Math.max(...keys);
                        }

                        var couponProducts = JSON.parse(sessionStorage.getItem("couponProductDetails"));
                        console.log(products);

                        var productArray = JSON.parse(JSON.stringify(products));
                        for (var i = 0; i < products.length; i++) {

                            for (var j = 0; j < couponProducts.length; j++) {


                                if (products[i].product_id == couponProducts[j].product_id && products[i].product_loyalty_enabled == "N" && couponProducts[j].coupon_details_type == "Q") {

                                    cartLength++;
                                    products[i].product_discount = sessionStorage.getItem("couponDiscount");
                                    products[i].product_discount_type = "H";
                                    products[i].cart_id = cartLength;

                                    productArray.push(products[i]);
                                    var dbconn = new db();
                                    dbconn.setOrder(products[i], cartLength).then(data => {

                                    });


                                }


                            }

                        }


                        productArray.map((item, index) => {

                            if (item.product_loyalty_enabled == "N") {

                                var discount = 0;
                                if (item.product_discount_type == "P" || item.product_discount_type == "H" || item.product_discount_type == "G") {

                                    discount = ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * parseFloat(item.product_discount)) / 100;

                                } else if (item.product_discount_type == "A") {
                                    discount = parseFloat(item.product_discount);
                                }

                                cartTotal += (((parseFloat(item.product_price) + parseFloat(item.mod_price)) - discount) * parseInt(item.product_quantity));

                            } else {
                                cartTotal += (parseFloat(item.mod_price) * parseInt(item.product_quantity));
                            }
                        });


                        sessionStorage.setItem('cartTotal', cartTotal);
                        this.setState({cartTotal: cartTotal});


                    });
                });
            } else {


                products.map((item, index) => {

                    if (item.product_loyalty_enabled == "N") {

                        var discount = 0;
                        if (item.product_discount_type == "P" || item.product_discount_type == "H" || item.product_discount_type == "G") {

                            discount = ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * parseFloat(item.product_discount)) / 100;

                        } else if (item.product_discount_type == "A") {
                            discount = parseFloat(item.product_discount);
                        }

                        cartTotal += (((parseFloat(item.product_price) + parseFloat(item.mod_price)) - discount) * parseInt(item.product_quantity));

                    } else {
                        cartTotal += (parseFloat(item.mod_price) * parseInt(item.product_quantity));
                    }
                });

                sessionStorage.setItem('cartTotal', cartTotal);
                this.setState({cartTotal: cartTotal});
            }
        });
    };
    plusQuantity = (product_id, position) => {

        var currentVal = parseInt($('#quant_' + product_id).val());
        var newVal = 0;


        var dbconn = new db();

        var cart_id = sessionStorage.getItem('editCartID');

        if (!isNaN(currentVal)) {

            if (currentVal < $('#quant_' + product_id).attr('max')) {
                newVal = currentVal + 1;
                $('#quant_' + product_id).val(newVal);

                $('#price_' + product_id).html("$" + ((this.state.displayList[position].product_price + this.state.displayList[position].modifier_price) * newVal).toFixed(2));


            } else if (parseInt($('#quant_' + product_id).val()) == $('#quant_' + product_id).attr('max')) {
                $('#btn-plus_' + product_id).attr('disabled', true);
            }
        } else {
            $('#quant_' + product_id).val(0);
        }
    };

    lessQuantity = (product_id, position) => {

        var currentVal = parseInt($('#quant_' + product_id).val(), 10);
        var newVal = 0;


        if (!isNaN(currentVal)) {
            if (currentVal > $('#quant_' + product_id).attr('min')) {

                newVal = currentVal - 1;
                $('#quant_' + product_id).val(newVal).change();


                $('#price_' + product_id).html("$" + ((this.state.displayList[position].product_price + this.state.displayList[position].modifier_price) * newVal).toFixed(2));


            }
            if (parseInt($('#quant_' + product_id).val(), 10) == $('#quant_' + product_id).attr('min')) {
                $('#btn-minus_' + product_id).attr('disabled', true);
            }
        } else {
            $('#quant_' + product_id).val(0);
        }
    };


    openNav = () => {

        $("#mySidenav").addClass('fullWidth');


    };

    closeNav = () => {
        $("#mySidenav").removeClass('fullWidth');

    };

    render() {
        const {t} = this.props;
        const {open} = this.state;

        if (this.state.sb != null) {
            this.state.sb.updateMetrics();
        }
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }
        if (this.state.cartredirect) {
            return (<Redirect to={'/order/view'}/>);
        }
        if (this.state.productDetailFlag) {
            return (<Redirect to={'/product/details'}/>);

        }

        return (
            <div className="mainContainer" style={{overflowY: "hidden"}}>
                <div className="left_panel_block bkg-red h-100 m-t-0">

                    <div className="left_panel_block_t">
                        <div className="site_logo p-t-10 bkg-white text-center">

                            <img src={IMAGE_ROOT + "/images/product/" + localStorage.getItem('store_image')}
                                 alt="Takecharge Dinner Logo"/>

                        </div>
                        <div className="search_block float_l w-100">

                            <input type="image" src="img/search-icon.png" className="float_l search_img"/>
                            <input type="text" id="searchTextSide"
                                   className="form-control" onKeyUp={this.searchProduct}
                                   placeholder={t('search_items') + "..."}/>

                        </div>
                        <div className="clearfix"></div>
                        <nav className="nav_side" id="nav_side">


                            {(this.state.productScheduleEnabled == "Y") ?
                                <a id="availLink" className="first" style={{fontWeight: 'bold', fontSize: '24px'}}
                                   onClick={() => {
                                       this.filterProducts(-1, "M")
                                   }}>{t('available_menu')}</a> :
                                <a id="homeLink2" className="first" style={{fontWeight: 'bold', fontSize: '24px'}}
                                   onClick={() => {
                                       this.filterProducts(0, "M")
                                   }}>{t('full_menu')}</a>}
                            {(this.state.productScheduleEnabled == "Y") ?
                                <a id="homeLink2" style={{fontWeight: 'bold', fontSize: '24px'}}
                                   onClick={() => {
                                       this.filterProducts(0, "M")
                                   }}>{t('full_menu')}</a> : ""}

                            {this.state.categoryList.map((item, index) => {


                                return (<a id={"leftcat_" + item.category_id} key={item.category_id}
                                           onClick={() => {
                                               this.filterProducts(item.category_id, "M")
                                           }}> {(localStorage.getItem("store_language")==="en")?item.category_name:(item["category_name_"+localStorage.getItem("store_language")]!=="")?item["category_name_"+localStorage.getItem("store_language")]:item.category_name} </a>);


                            })


                            }


                        </nav>


                    </div>
                    <div className="bkg-red overflow privacyBlock" style={{bottom: "0px"}}>

                        <Link id="policyLink" to={'/refundpolicy'}> {t('refund_policy')}</Link>
                        |
                        <Link id="policyLink" to={'/policy'}> {t('privacy_policy')} </Link>
                        |
                        <Link id="tosLink" to={'/terms'}> {t('tos')} </Link>

                    </div>


                </div>
                <div className="right_panel h-100">
                    <header className="okayNav-header">
                        <div className="col-md-12 col-sm-12 col-xs-12 desk-block">
                            <div className="row">
                                <div className="float_l">
                                    <h2>{localStorage.getItem('store_name')}</h2>
                                </div>
                                <div className="float_r">
                                    <ul className="sign_in_up m-b-0">


                                        {(sessionStorage.getItem('guestFlag') == 'N') ?
                                            <span> <li><Link to={'/rewards'}
                                                             className="p_r_10">{this.state.loyaltyPoints+" "+ i18n.t('points')}</Link></li><li>|</li><li><Link
                                                id="accountLink"
                                                to={'/myaccount'}> {t('my_account')} </Link></li></span>
                                            : <span><li><Link to={'/login'} className="p_r_10">{t('login')}</Link></li><li>|</li> <li> <Link
                                                to={'/signup'}>{t('signup')}</Link></li></span>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12 mob-block">

                            <div className="searchDiv" id="btnSearch" onClick={this.searchClick}
                                 style={{display: "inline"}}><img src="/img/search.png"
                                                                  style={{
                                                                      width: "30px",
                                                                      height: "30px"
                                                                  }}/></div>
                            <div className="searchContainer">

                                <div id="menuContainer">
                                    <div id="topnav" className="topnav">

                                        <div className="innerDiv">


                                            {(this.state.productScheduleEnabled == "Y") ?
                                                <a className="first" id="availLink1"
                                                   style={{fontWeight: 'bold', fontSize: '24px'}}
                                                   onClick={() => {
                                                       this.filterProducts(-1, "M")
                                                   }}>{t('available_menu')}</a>
                                                : <a className="first" id="homeLink"
                                                     style={{fontWeight: 'bold', fontSize: '24px'}}
                                                     onClick={() => {
                                                         this.filterProducts(0, "M")
                                                     }}>{t('menu')}</a>
                                            }
                                            {(this.state.productScheduleEnabled == "Y") ?
                                                <a id="homeLink"
                                                   style={{fontWeight: 'bold', fontSize: '24px'}}
                                                   onClick={() => {
                                                       this.filterProducts(0, "M")
                                                   }}>{t('menu')}</a>
                                                : ""}


                                            {this.state.categoryList.map((item, index) => {


                                                return (<a id={"cat_" + item.category_id} key={item.category_id}
                                                           onClick={() => {
                                                               this.filterProducts(item.category_id, "M")
                                                           }}> {(localStorage.getItem("store_language")==="en")?item.category_name:(item["category_name_"+localStorage.getItem("store_language")]!=="")?item["category_name_"+localStorage.getItem("store_language")]:item.category_name} </a>);


                                            })


                                            }

                                            {(sessionStorage.getItem('guestFlag') == 'N') ?
                                                <Link id="accountLink" to={'/myaccount'}> {t('my_account')} </Link>
                                                : ""}


                                        </div>
                                    </div>

                                    <span id="sandwich"
                                          onClick={this.openNav}>&#9776;</span>

                                </div>
                                <div className="searchText" onKeyUp={this.searchProduct} id="searchText"
                                     style={{display: "none", marginTop: "5px"}}><input
                                    type="text" placeholder={t('search_items') + "..."}/></div>


                            </div>

                        </div>


                        <div id="mySidenav" style={{
                            paddingBottom: "50px"
                        }} className="sidenav">


                            <a style={{padding: "0px"}} href="javascript:void(0)" className="closebtn"
                               onClick={this.closeNav}>&times;</a>
                            {(sessionStorage.getItem('guestFlag') == 'N') ?
                                <div className="bkg_box_black p-0">

                                    <Link id="accountLink" style={{paddingLeft: "10px"}}
                                          to={'/myaccount'}> {t('my_account')} </Link>


                                    <hr style={{
                                        marginTop: "0px",
                                        marginBottom: "5px",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        border: "2px solid #fff"
                                    }}/>

                                    <h3 style={{
                                        color: "#fff",
                                        display: "inline-block",
                                        margin: "10px"
                                    }}>{this.state.loyaltyPoints+" "+ i18n.t('points')}</h3>
                                    <Link className="a_link" to={'/rewards'} style={{
                                        float: "right",
                                        padding: "6px",
                                        fontSize: "18px",
                                        margin: "5px",
                                        border: "0px"
                                    }}>{t('redeem')}</Link>

                                </div>
                                : ""}
                            <div className="innerDiv" style={{display: "inline-block", width: "100%"}}>


                                {(this.state.productScheduleEnabled == "Y") ?
                                    <a id="availLink2" className="first" href="#" onClick={() => {
                                        this.availHomeLinkClick()
                                    }}>{t('available_menu')}</a>
                                    : <a id="homeLink1" className="first" href="#" onClick={() => {
                                        this.homeLink1Click()
                                    }}>{t('menu')}</a>
                                }
                                {(this.state.productScheduleEnabled == "Y") ?
                                    <a id="homeLink1" href="#" onClick={() => {
                                        this.homeLink1Click()
                                    }}>{t('menu')}</a>
                                    : ""}


                                {this.state.categoryList.map((item, index) => {


                                    return (<a id={"sideCat_" + item.category_id} key={item.category_id}
                                               onClick={() => {
                                                   this.filterProducts(item.category_id, "S")
                                               }}> {(localStorage.getItem("store_language")==="en")?item.category_name:(item["category_name_"+localStorage.getItem("store_language")]!=="")?item["category_name_"+localStorage.getItem("store_language")]:item.category_name}</a>);
                                })}

                                {(sessionStorage.getItem('guestFlag') == 'Y') ?
                                    <Link id="accountLink" to={'/login'}> {t('login')} </Link>
                                    : ""}

                                {(sessionStorage.getItem('guestFlag') == 'N') ?
                                    <a id="btnLogout" key="987"
                                       onClick={() => {
                                           this.logout();
                                       }}> {t('signout')} </a>

                                    : ""}
                                <Link id="contactLink" to={'/contact'}> {t('contact')} </Link>
                                <Link id="tosLink" to={'/terms'}>{t('tos')} </Link>
                                <Link id="policyLink" to={'/policy'}> {t('privacy_policy')} </Link>
                                <Link id="policyLink" to={'/refundpolicy'}> {t('refund_policy')} </Link>
                            </div>
                        </div>
                        <span onClick={this.openNav}></span>
                    </header>
                    <div className="clearfix"></div>
                    <div className="h_content bkg-white w-75 float_l desk-block">
                        <div className="float_l">
                            <p className="m-b-0">{localStorage.getItem("store_address")}, {localStorage.getItem("store_city")}, {localStorage.getItem("store_state")} {localStorage.getItem("store_zip")}</p>
                        </div>
                        <div className="float_r">
                            <p className="m-b-0">{t('phone')}: {localStorage.getItem("store_phone")}</p>
                        </div>
                    </div>
                    <div className="p-t-55">


                        <div className="searchClass" id="searchList">

                            <div className="searchLabel" id="searchLabel">{t('search_results')}</div>
                            <div className="searchScrollClass" style={{paddingBottom: "200px"}}>
                                {this.state.searchList.map((item, index) => {

                                    var productPrice = 0;
                                    var productQty = 1;

                                    if (this.state.buildItemProductID > 0 && item.product_id == this.state.buildItemProductID) {
                                        productPrice = this.state.buildItemProductPrice;
                                        productQty = this.state.buildItemProductQty;
                                    } else {
                                        productPrice = parseFloat(item.product_price) + parseFloat(item.modifier_price);
                                    }
                                    var padd = "0px";
                                    if (index == this.state.displayList.length - 1) {
                                        padd = "52px";
                                    }


                                    var productWidth = "";
                                    if (item.product_image != "") {
                                        productWidth = "col-md-9 col-sm-7 col-xs-7";
                                    } else {
                                        productWidth = "col-md-12 col-sm-12 col-xs-12";
                                    }


                                    var productMarginRight = "";

                                    if (item.product_image != "") {


                                    } else {
                                        productMarginRight = "0px";
                                    }

                                    return (

                                        <div>
                                            {(item.product_enabled == "Y") ?
                                                <div key={item.product_id}
                                                     className="product-main-block bkg-white-border-15 enableProduct"
                                                     onClick={() => {
                                                         this.clickSearchProduct(item.product_id, index)
                                                     }}>
                                                    <div className="simple-box simple-box-w-100 m-b-0">
                                                        <div className="product-block">
                                                            {(item.product_image != "") ?
                                                                <div className="col-md-3 col-sm-5 col-xs-5">
                                                                    <div className="row">
                                                                        <div className="product-img">
                                                                            <img id={'product_image_' + item.product_id}
                                                                                 src={IMAGE_ROOT + "/images/product/" + item.product_image}
                                                                                 alt="Product Image"/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                : ''}

                                                            <div className={productWidth} style={{marginBottom: padd}}>
                                                                <div className="product-info">
                                                                    <h4 id={'product_name_' + item.product_id}> {(localStorage.getItem("store_language")==="en")?item.product_name:(item["product_name_"+localStorage.getItem("store_language")]!=="")?item["product_name_"+localStorage.getItem("store_language")]:item.product_name} </h4>
                                                                    <div className="product-price float_l m-t-5 m-r-10"
                                                                         style={{paddingRight: '20px'}}>
                                                                        <p className="text-left"
                                                                           id={'price_' + item.product_id}>${productPrice.toFixed(2)} </p>
                                                                    </div>

                                                                </div>

                                                                <div
                                                                    className="product-content product-content1 p-t-15 p-b-10"
                                                                    style={{width: "100%", marginLeft: "0px"}}>

                                                                    <p className="text-left"> {(localStorage.getItem("store_language")==="en")?item.product_description:(item["product_description_"+localStorage.getItem("store_language")]!=="")?item["product_description_"+localStorage.getItem("store_language")]:item.product_description} </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                : <div key={item.product_id}
                                                       className="product-main-block bkg-white-border-15 disableProduct"
                                                       onClick={() => {
                                                           this.itemNotAvailable(item.product_schedule)
                                                       }}>
                                                    <div className="simple-box simple-box-w-100 m-b-0">
                                                        <div className="product-block">
                                                            {(item.product_image != "") ?
                                                                <div className="col-md-3 col-sm-5 col-xs-5">
                                                                    <div className="row">
                                                                        <div className="product-img">
                                                                            <img id={'product_image_' + item.product_id}
                                                                                 src={IMAGE_ROOT + "/images/product/" + item.product_image}
                                                                                 alt="Product Image"/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                : ''}

                                                            <div className={productWidth} style={{marginBottom: padd}}>
                                                                <div className="product-info">
                                                                    <h4 id={'product_name_' + item.product_id}> {(localStorage.getItem("store_language")==="en")?item.product_name:(item["product_name_"+localStorage.getItem("store_language")]!=="")?item["product_name_"+localStorage.getItem("store_language")]:item.product_name} </h4>
                                                                    <div className="product-price float_l m-t-5 m-r-10"
                                                                         style={{paddingRight: '20px'}}>
                                                                        <p className="text-left"
                                                                           id={'price_' + item.product_id}>${productPrice.toFixed(2)} </p>
                                                                    </div>

                                                                </div>

                                                                <div
                                                                    className="product-content product-content1 p-t-15 p-b-10"
                                                                    style={{width: "100%", marginLeft: "0px"}}>

                                                                    <p className="text-left"> {(localStorage.getItem("store_language")==="en")?item.product_description:(item["product_description_"+localStorage.getItem("store_language")]!=="")?item["product_description_"+localStorage.getItem("store_language")]:item.product_description}  </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>}
                                        </div>


                                    );
                                })}
                            </div>


                        </div>
                        <div className="scrollClass" id="productList">


                            {this.state.displayList.map((item, index) => {

                                var productPrice = 0;
                                var productQty = 1;

                                if (this.state.buildItemProductID > 0 && item.product_id == this.state.buildItemProductID) {
                                    productPrice = this.state.buildItemProductPrice;
                                    productQty = this.state.buildItemProductQty;
                                } else {
                                    productPrice = parseFloat(item.product_price) + parseFloat(item.modifier_price);
                                }
                                var padd = "0px";
                                if (index == this.state.displayList.length - 1) {
                                    padd = "52px";
                                }
                                var productWidth = "";

                                if (item.product_image != "") {
                                    productWidth = "col-md-9 col-sm-7 col-xs-7";
                                } else {
                                    productWidth = "col-md-12 col-sm-12 col-xs-12";
                                }

                                var productMarginRight = "";

                                if (item.product_image != "") {


                                } else {
                                    productMarginRight = "0px";
                                }

                                return (
                                    <div key={item.product_id} className="product-main-block bkg-white-border-15">
                                        <div className="simple-box simple-box-w-100 m-b-0">
                                            <div className="product-block">
                                                {(item.product_image != "") ?
                                                    <div className="col-md-3 col-sm-5 col-xs-5">
                                                        <div className="row">
                                                            <div className="product-img">
                                                                <img id={'product_image_' + item.product_id}
                                                                     src={IMAGE_ROOT + "/images/product/" + item.product_image}
                                                                     alt="Product Image"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : ''}
                                                <div className={productWidth} style={{marginBottom: padd}}>
                                                    <div className="product-info">
                                                        <h4 id={'product_name_' + item.product_id}> {(localStorage.getItem("store_language")==="en")?item.product_name:(item["product_name_"+localStorage.getItem("store_language")]!=="")?item["product_name_"+localStorage.getItem("store_language")]:item.product_name}</h4>
                                                        <div className="product-price float_l m-t-5 m-r-10"
                                                             style={{paddingRight: '20px'}}>
                                                            <p className="text-left"
                                                               id={'price_' + item.product_id}>${productPrice.toFixed(2)} </p>
                                                        </div>
                                                        <div className="input-group">
                                                  <span className="input-group-btn">
                                                      <button type="button" id={"btn-minus_" + item.product_id}
                                                              name={"btn-minus_" + item.product_id} onClick={() => {
                                                          this.lessQuantity(item.product_id, index)
                                                      }} className="btn-number" data-type="minus" data-field="quant[2]">
                                                        <span className="quty-icon minus-icon">-</span>
                                                      </button>
                                                  </span>
                                                            <input type="text" disabled={true} readOnly={true}
                                                                   id={"quant_" + item.product_id}
                                                                   name={"quant_" + item.product_id}
                                                                   className="form-control input-number"
                                                                   min="1" max="99" defaultValue={productQty}/>
                                                            <span className="input-group-btn">
                                                      <button type="button" id={"btn-plus_" + item.product_id}
                                                              name={"btn-plus_" + item.product_id} onClick={() => {
                                                          this.plusQuantity(item.product_id, index)
                                                      }} className="btn-number" data-type="plus" data-field="quant[2]">
                                                          <span className="quty-icon plus-icon">+</span>
                                                      </button>
                                                  </span>
                                                        </div>
                                                        <div className="form-group float_l clear">

                                                            {(item.product_enabled == "Y") ?

                                                                <div className="form-group float_l clear w-100">
                                                                    <input type="button"
                                                                           className="form-control font  m-b-0 m-t-13 m-r-10 float_l radius-0"
                                                                           name="buildItemBtn"
                                                                           style={{marginLeft: "0px"}}
                                                                           id="buildItemBtn" onClick={() => {
                                                                        this.goToProduct(item.product_id, index)
                                                                    }} value={t('add_to_cart')}/>
                                                                </div>
                                                                : <div className="form-group float_l clear w-100">
                                                                    <input type="button"
                                                                           className="form-control font  m-b-0 m-t-13 m-r-10 float_l radius-0 link_button_disabled"
                                                                           name="buildItemBtn"
                                                                           style={{marginLeft: "0px"}}
                                                                           id="buildItemBtn" value={t('add_to_cart')}
                                                                           onClick={() => {
                                                                               this.itemNotAvailable(item.product_schedule)
                                                                           }}/>
                                                                </div>}


                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="product-content product-content1 p-t-15 p-b-10"
                                                     style={{paddingLeft: "12px",paddingTop:"10px"}}>
                                                    <p className="text-left"> {(localStorage.getItem("store_language")==="en")?item.product_description:(item["product_description_"+localStorage.getItem("store_language")]!=="")?item["product_description_"+localStorage.getItem("store_language")]:item.product_description}  </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>);
                            })}
                        </div>

                    </div>
                    <div className="black-bottom-box">
                        <div className="black-bottom-box-inner w-75">
                            <p>Total: ${parseFloat(this.state.cartTotal).toFixed(2)}</p>
                            <button style={{float: "right", border: "none"}} onClick={this.openCart.bind(this)}
                                    className="a_link">{t('view_cart')}
                            </button>
                        </div>
                    </div>


                </div>

                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>


                <Notifications options={{zIndex: 9999, width: '100%', top: '50px'}}/>
                <Language/>
                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(home));



// WEBPACK FOOTER //
// ./src/view_components/home.js